import { takeLatest, call, put, select } from 'redux-saga/effects'
import log from 'loglevel';

import axios from "../../utils/axios";
import getEnvParam from '../../utils/getEnvParam';
import convertBase64 from '../../helpers/convertBase64'
import messages from "../../assets/i18n";

const producerDeclarationFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

function* producerDeclaration(orderId, file, token) {

  // const { orderId, file } = payload;

	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
				declaracaoProdutor(orderId: "${orderId}", file: "${file}")
			}`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* lastProducerDeclaration(payload, token) {

  const { orderId } = payload;

	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				buscarUltimaDeclaracao(orderId: "${orderId}") {
					id 
					file
					status {
						id
						descricao
					}
				}
			}
			`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

    if (data.buscarUltimaDeclaracao) {
      yield put({ type: "SET_LAST_PRODUCER_DECLARATION", payload: data.buscarUltimaDeclaracao.file});
    }

		return data
	} catch (error) {
		log.info(error);
	}
}

function* declarations(token, page = 1, filter, size = 20) {
	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				listarTodasFiltradas(
				 nomeFornecedor: "${filter.fornecedor.nome ? filter.fornecedor.nome : ""}"
				 status: "${filter.declaracao.status ? filter.declaracao.status : ""}"
				 dataPedidoInicial: "${filter.pedido.dataInicial ? filter.pedido.dataInicial : ""}"
				 dataPedidoFinal: "${filter.pedido.dataFinal ? filter.pedido.dataFinal : ""}"
				 dataCadastroInicial: "${filter.declaracao.dataInicial ? filter.declaracao.dataInicial : ""}"
				 dataCadastroFinal: "${filter.declaracao.dataFinal ? filter.declaracao.dataFinal : ""}"
				 pedido: "${filter.pedido.id ? filter.pedido.id : ""}"
				 pagina: ${page}
				 max: ${size}
				 orderBy: "${filter.orderBy ? filter.orderBy : ""}"
				 ) {
				 id
				 pedido {
					 id
					 fornecedor {
						 id
						 nome
					 }
				 }
				 statusFecomercio {
					 id
					 descricao
				 }
				 status {
					 id
					 descricao
				 }
				 statusRMS {
					id
					descricao
				 }
				 erroEnvioRMS
				 dataCadastro
				 normaDeclaracaoProdutor {id codigo descricao}
			 	}
		 	}`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* declarationDetails(payload, token) {
	try {
		const { id } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				declaracaoAuditoriaPorId (id: "${id}") {
					id
					dataDeclaracao
					dataValidade
					dataCadastro
					dataDJO
					numeroDJO
					itemFOBMax
					itemFOBMin
					normaDeclaracaoProdutor {
						id
						codigo
						descricao			
					}
					pedido {
						id 
						fornecedor {
							id
							nome
						}
						dtEmissao
						items {
							id
							codItem
							detalheItems {
								id
								descricaoItem
								descricaoCurta
							}
						}
					}
					status {
						id
						descricao
					}
					statusFecomercio {
						id
						descricao
					}
				}
			}`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* declarationNorms(payload, token) {
	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_NORMA_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				listarTodas {
					id
					codigo
					descricao
					dataCriacao
					ativo
				}
			}`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* normDetails(payload, token) {
	try {
		const { id } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_NORMA_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				buscarPorId(id: ${id}) {
					id
					codigo
					ativo
					descricao
					dataCriacao
				}
			}`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* newNorm(payload, token) {
	try {
		const { descricao, codigo, ativo } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_NORMA_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
				criarNorma(
					codigo: "${codigo}", 
					descricao: "${descricao}"
					ativo: "${ativo}")
			}`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* editNorm(payload, token) {
	try {
		const { id, descricao, codigo, ativo } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_NORMA_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
				atualizarNorma(
					id: ${id}
					codigo: "${codigo}", 
					descricao: "${descricao}"
					ativo: "${ativo}") {
						id
					}
			}`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* updateDeclarationDetails(payload, token) {
	try {
		const { 
			id,
			pedido,
			dataDeclaracao,
			dataValidade,
			dataCadastro,
			status,
			statusFecomercio,
			itemFOBMin,
			itemFOBMax,
			dataDJO,
			numeroDJO,
			file,
			normaDeclaracaoProdutor
		 } = payload;

		var base64 = file ? yield convertBase64(file) : '';
		var norma = normaDeclaracaoProdutor;
		if (normaDeclaracaoProdutor && normaDeclaracaoProdutor.codigo !== undefined) {
			norma  = normaDeclaracaoProdutor.codigo
		}

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
				atualizarDeclaracaoAuditoria (declaracaoAuditoria: {
					id: ${id}
					normaDeclaracaoProdutor: "${norma || ""}"
					statusFecomercio: ${statusFecomercio.id}
					itemFOBMax: "${itemFOBMax ? itemFOBMax : ''}"
					dataDeclaracao: "${dataDeclaracao ? dataDeclaracao : ''}",
					dataValidade: "${dataValidade ? dataValidade : ''}",
					itemFOBMin: "${itemFOBMin ? itemFOBMin : ''}",
					dataDJO: "${dataDJO ? dataDJO : ''}",
					numeroDJO: "${numeroDJO ? numeroDJO : ''}",
					dataCadastro: "${dataCadastro ? dataCadastro : ''}",
					status: ${status.id},
					file: "${base64}"
				})
			}
			`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		yield put({
			type: 'SET_SELECTED_DECLARATION',
			payload: {id: id, pedido: pedido.id }
		})

		return data
	} catch (error) {
		log.info(error);
	}
}

function* setProducerDeclaration({payload}) {
  try{
    const { token } = yield select(state => state.authentication );

    yield put({ type: "SET_LOADING_PRODUCER_DECLARATION", payload: true});

    const base64 = yield convertBase64(payload.file);

    yield call(producerDeclaration, payload.orderId, base64, token);
	
    yield put({ type: "SET_LOADING_PRODUCER_DECLARATION", payload: false});
    
  } catch (error) {
    log.info(error);
  }
}

function* getLastProducerDeclaration({payload}) {
  try{
    const { token } = yield select(state => state.authentication );

    yield put({ type: "SET_LOADING_LAST_DECLARATION", payload: true});
        
    const result = yield call(lastProducerDeclaration, payload, token);

	if (result && result.buscarUltimaDeclaracao) {
		if (result.buscarUltimaDeclaracao) {
			yield put({ type: "SET_LAST_FILE_STATUS", payload: result.buscarUltimaDeclaracao.status.descricao});
		} else {
			yield put({ type: "SET_LAST_FILE_STATUS", payload: ''});
		}
	} else {
		yield put({ type: "SET_LAST_FILE_STATUS", payload: ''});
	}

    yield put({ type: "SET_LOADING_LAST_DECLARATION", payload: false});
    
  } catch (error) {
    log.info(error);
  }
}

function* getDeclarations({page, filter, cleanTable}) {
	try {
		const { token } = yield select(state => state.authentication);		
		const nextPage = page + 1;
		let hasMoreResults
		let result

		yield put({ 
			type: "DECLARATION_HAS_MORE_LOADING", 
			payload: true
		});

		if (cleanTable) {
			yield put({ 
				type: "CLEAN_DECLARATION_LIST",
			});
		}

		result = yield call(declarations, token, page, filter);
	
		if (result) {
			const resultHasMore = yield call(declarations, token, nextPage, filter);

			if (resultHasMore && resultHasMore.listarTodasFiltradas && resultHasMore.listarTodasFiltradas.length) {
				hasMoreResults = true
			} else {
				hasMoreResults = false
			}

			if (result.listarTodasFiltradas && result.listarTodasFiltradas.length) {
				yield put({ 
					type: "SET_PRODUCER_DECLARATION_LIST", 
					payload: {
						list: result.listarTodasFiltradas,
						hasMore: hasMoreResults,
						page: nextPage,
					}
				});
			}
        }

		yield put({ 
			type: "DECLARATION_HAS_MORE_LOADING", 
			payload: false
		});
	} catch (error) {
		log.info(error);
	}
}

function* getDeclarationDetails(payload) {
	try {
		yield put({ type: "CLEAN_DECLARATION_DETAILS" });
		yield put({ type: "SET_LOADING_DECLARATION_DETAILS", payload: true });

		const { token } = yield select(state => state.authentication);
		
		const result = yield call(declarationDetails, payload, token);

		if (result && result.declaracaoAuditoriaPorId) {
            yield put({ type: "SET_DECLARATION_DETAILS", payload: result.declaracaoAuditoriaPorId});
        }

		yield put({ type: "UNSET_SELECTED_DECLARATION" });
		yield put({ type: "SET_LOADING_DECLARATION_DETAILS", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* updateDeclaration(payload) {
	try {
		yield put({ type: "SET_LOADING_DECLARATION_UPDATE", payload: true });

		const { token } = yield select(state => state.authentication);
		
		const lang = yield select(state => state.language.name);

		const result = yield call(updateDeclarationDetails, payload.declaration, token);

		if (result && result.atualizarDeclaracaoAuditoria) {
			if (result.atualizarDeclaracaoAuditoria === "OK!") {
				yield put({ 
					type: "SET_DECLARATION_DETAILS_TOAST", 
					payload: {
						showToast: true,
						message: messages[lang].registerSuccess,
						messageType: "toast-success"
					}});
			}
        } else {
			yield put({ 
				type: "SET_DECLARATION_DETAILS_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerError,
					messageType: "toast-error"
				}});
		}
		yield put({ type: "SET_LOADING_DECLARATION_UPDATE", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* getDeclarationNorms(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        
		const result = yield call(declarationNorms, payload, token);
                        
		if (result && result.listarTodas) {
            yield put({ type: "SET_NORM_LIST", payload: result.listarTodas});
        }
	} catch (error) {
		log.info(error);
	}
}

function* getNormDetails(payload) {
	try {
		yield put({ type: "SET_LOADING_NORM_DETAILS", payload: true });
		const { token } = yield select(state => state.authentication);
        
		const result = yield call(normDetails, payload, token);

		if (result && result.buscarPorId) {
			yield put({ type: "UNSET_SELECTED_NORM"});
            yield put({ type: "SET_NORM_DETAILS", payload: result.buscarPorId});
        }
		yield put({ type: "SET_LOADING_NORM_DETAILS", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* createNorm(payload) {
	try {
		yield put({ type: "SET_LOADING_NORM_SAVE", payload: true });

		const { token } = yield select(state => state.authentication);

		const lang = yield select(state => state.language.name);

		const result = yield call(newNorm, payload.payload, token);

		if (result && result.criarNorma) {
			yield put({ type: "SET_LOAD_NORM_DETAILS", payload: result.criarNorma});

			yield put({ 
				type: "SET_NORM_DETAILS_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerSuccess,
					messageType: "toast-success"
				}});
        } else {
			yield put({ 
				type: "SET_NORM_DETAILS_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerError,
					messageType: "toast-error"
				}});
		}
		yield put({ type: "SET_LOADING_NORM_SAVE", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* updateNorm(payload) {
	try {
		yield put({ type: "SET_LOADING_NORM_SAVE", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);

		const result = yield call(editNorm, payload.payload, token);

		if (result && result.atualizarNorma) {
			yield put({ 
				type: "SET_NORM_DETAILS_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerSuccess,
					messageType: "toast-success"
				}});
        } else {
			yield put({ 
				type: "SET_NORM_DETAILS_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerError,
					messageType: "toast-error"
				}});
		}
		yield put({ type: "SET_LOADING_NORM_SAVE", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* getOrderDeclarationHistory(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const result = yield call(declarationHistory, payload, token);

		if (result) {
            yield put({ type: "SET_DECLARATION_HISTORY_LIST", payload: result});
        }
	} catch (error) {
		log.info(error);
	}
}

function* declarationHistory(payload, token) {
	try {
		const { orderId } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				buscarHistoricoPorPedido(orderId: "${orderId}") {
					id
					dataCadastro
					status {id descricao}
					file
				}
			}`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* getDeclarationCsvDownload({filter}) {
	try {
		yield put({ type: "SET_DECLARATION_CSV_LOADING", payload: true});

		const { token } = yield select(state => state.authentication);

		const result = yield call(declarations, token, 1, filter, 10000);

		if (result && result.listarTodasFiltradas) {
            yield put({ type: "SET_DECLARATION_CSV_LIST", payload: result.listarTodasFiltradas});
        }
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_DECLARATION_CSV_LOADING", payload: false});
	}
}

function* getDeclarationFileDownload(payload) {
	try {
		yield put({ type: "SET_DOWNLOAD_DECLARATION_LOADING", payload: true});

		const { token } = yield select(state => state.authentication);

		const result = yield call(declarationFileDownload, payload, token);

		if (result && result.buscarArquivoPorIdDeclaracao) {
            yield put({ type: "SET_DOWNLOAD_DECLARATION_FILE", payload: result.buscarArquivoPorIdDeclaracao});
        }
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_DOWNLOAD_DECLARATION_LOADING", payload: false});
	}
}

function* declarationFileDownload(payload, token) {
	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_DECLARACAO_PRODUTOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				buscarArquivoPorIdDeclaracao (id: ${payload.payload})
			}
			`
		};

		const { data } = yield call(producerDeclarationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

// Generator function
export function* producerDeclarationWatcher() {
  yield takeLatest("SET_PRODUCER_DECLARATION", setProducerDeclaration);  
  yield takeLatest("GET_LAST_PRODUCER_DECLARATION", getLastProducerDeclaration);
  yield takeLatest("GET_DECLARATIONS", getDeclarations);
  yield takeLatest("GET_DECLARATION_DETAILS", getDeclarationDetails);
  yield takeLatest("UPDATE_DECLARATION", updateDeclaration);
  yield takeLatest("GET_DECLARATION_NORMS", getDeclarationNorms);
  yield takeLatest("GET_NORM_DETAILS", getNormDetails);
  yield takeLatest("CREATE_NORM", createNorm);
  yield takeLatest("UPDATE_NORM", updateNorm);
  yield takeLatest("GET_ORDER_DECLARATION_HISTORY", getOrderDeclarationHistory);
  yield takeLatest("GET_DECLARATION_CSV_DOWNLOAD", getDeclarationCsvDownload);
  yield takeLatest("GET_DECLARATION_FILE_DOWNLOAD", getDeclarationFileDownload);
}